document.addEventListener('click', async (event) => {
  window.dataLayer = window.dataLayer || [];
  const productLink = event.target.closest('[data-product-card] a');
  if (!productLink) return;
  event.preventDefault();

  const productClicked = event.target.closest('[data-product-card]');
  const { productHandle } = productClicked.dataset;

  try {
    const productRequestUrls = [
      `${Shopify.routes.root}products/${productHandle}.js`,
      `${Shopify.routes.root}products/${productHandle}?view=json`,
    ];

    const data = await Promise.all((productRequestUrls.map(async (url) => {
      const resp = await fetch(url);
      return resp.json();
    })));

    const [productClickedData, metafields] = data;

    const form = productClicked.querySelector('product-form');
    let currentVariant = null;
    if (form) {
      const variantId = parseInt(form.querySelector('input[name="id"]').value, 10);
      currentVariant = productClickedData.variants.find((variant) => variant.id === variantId);
    }
    window.dataLayer.push({
      event: 'productClick',
      ecommerce: {
        currencyCode: Shopify.currency.active,
        click: {
          products: [{
            name: productClickedData.title,
            id: currentVariant ? currentVariant.sku : productClickedData.sku,
            price: currentVariant ? currentVariant.price / 100 : productClickedData.price / 100,
            brand: productClickedData.vendor,
            category: productClickedData.type,
            dimension1: currentVariant ? currentVariant.title : null,
            dimension2: currentVariant ? currentVariant.id : productClickedData.variants[0].id,
            dimension3: metafields.scent || "",
            dimension4: metafields.key_ingredient || "",
            dimension5: metafields.skin_type || "",
            dimension6: metafields.hair_type || ""
          }],
        },
      },
    });
    console.log('%cEvent: productClick', 'color: #FF9100');
    console.log(window.dataLayer);
  } catch (err) {
    console.error(err);
  } finally {
    window.location.href = productLink.getAttribute('href');
  }
});